import React, { useState, useEffect } from "react";
import { Table, Modal, Button, notification, Input } from "antd";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


const LienUtileAdmin = () => {
  const [nom, setNom] = useState("");
  const [lien, setLien] = useState("");
  const [liens, setLiens] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [viewingLien, setViewingLien] = useState(null);
  const [editingLien, setEditingLien] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteLien, setDeleteLien] = useState(null);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "...";
      }
      return text;
    } else {
      return "";
    }
  };

  const fetchLiens = async () => {
    try {
      const response = await baseApiUrl.get("/liens-utiles");

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = response.data;

      if (!data || data.length === 0) {
        console.warn("Aucun lien utile trouvé.");
      }

      setLiens(data);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des liens utiles:",
        error.message || error
      );
      openNotificationWithIcon(
        "error",
        "Erreur lors de la récupération des liens utiles."
      );
    }
  };

  useEffect(() => {
    fetchLiens();
  }, []);

  const handleAddLien = async (e) => {
    e.preventDefault();

    if (!nom || !lien) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      // Création de l'objet lien utile
      const lienData = {
        nom,
        lien
      };

      // Effectuer l'appel API
      const response = await baseApiUrl.post("/liens-utiles", lienData);

      const newLien = response.data;

      console.log("Réponse API :", newLien);

      setLiens([newLien, ...liens]);

      openNotificationWithIcon("success", "Lien utile ajouté avec succès.");
      fetchLiens();
      setIsAddModalVisible(false);
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du lien utile.");
      console.error("Erreur détectée :", error.response?.data || error.message || error);
    }

    resetForm();
  };

  const handleEditLien = async (e) => {
    e.preventDefault();

    if (!editingLien) {
      openNotificationWithIcon("error", "Aucun lien sélectionné pour la modification.");
      return;
    }

    if (!nom || !lien) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      // Création de l'objet lien utile avec ID pour la mise à jour
      const lienData = {
        id: editingLien.id,
        nom,
        lien
      };

      const response = await baseApiUrl.put(`/liens-utiles/${editingLien.id}`, lienData);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedLien = response.data;
      console.log("Lien mis à jour:", updatedLien);

      setLiens(
        liens.map((lienItem) => (lienItem.id === updatedLien.id ? updatedLien : lienItem))
      );

      openNotificationWithIcon("success", "Lien utile modifié avec succès.");
      setIsEditModalVisible(false);
      await fetchLiens();
    } catch (error) {
      console.error("Erreur lors de la modification du lien:", error);
      console.error("Détails:", error.response?.data);
      openNotificationWithIcon("error", "Erreur lors de la modification du lien utile.");
    }

    resetForm();
  };

  const handleEdit = (lien) => {
    setViewingLien(lien);
    setEditingLien(lien);
    setNom(lien.nom);
    setLien(lien.lien);

    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (lien) => {
    setDeleteLien(lien);
    setDeleteModalVisible(true);
  };

  const handleDelete = async (idLien) => {
    try {
      const response = await baseApiUrl.delete(`/liens-utiles/${idLien}`);

      if (response.status !== 200 && response.status !== 204) {
        console.error(`Statut inattendu : ${response.status}`);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setLiens((prevLiens) =>
        prevLiens.filter((lien) => lien.id !== idLien)
      );

      setDeleteModalVisible(false);
      setDeleteLien(null);

      openNotificationWithIcon("success", "Lien utile supprimé avec succès.");
    } catch (error) {
      console.error("Erreur lors de la suppression :", error.message || error);
      openNotificationWithIcon(
        "error",
        "Une erreur est survenue lors de la suppression du lien utile."
      );
    }
  };

  const resetForm = () => {
    setIsEditModalVisible(false);
    setIsAddModalVisible(false);
    setIsViewModalVisible(false);
    setNom("");
    setLien("");
    setEditingLien(null);
  };

  const handleView = (lien) => {
    setViewingLien(lien);
    setIsViewModalVisible(true);
  };

  const filteredLiens = liens.filter((lien) => {
    return (
      lien.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lien.lien.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Liens Utiles</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom ou lien"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="success"
                  onClick={() => {
                    resetForm();
                    setIsAddModalVisible(true);
                  }}
                  className="float-end mt-2 btn-success"
                >
                 <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                                  Ajouter un lien
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "Nom",
                dataIndex: "nom",
                key: "nom",
                render: (text) => truncateText(text, 6),
              },
              {
                title: "Lien",
                dataIndex: "lien",
                key: "lien",
                render: (text) => truncateText(text, 8),
              },
              {
                title: "Date de création",
                dataIndex: "created",
                key: "created",
                render: (date) => new Date(date).toLocaleDateString("fr-FR"),
              },
              {
                title: "Dernière mise à jour",
                dataIndex: "updated",
                key: "updated",
                render: (date) => new Date(date).toLocaleDateString("fr-FR"),
              },
              {
                key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => {
                        resetForm();
                        handleView(record);
                      }}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => {
                        resetForm();
                        handleEdit(record);
                      }}
                    >
                      Modifier
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },
            ]}
            dataSource={filteredLiens}
          />

          {/* Modal d'ajout de lien */}
          <Modal
            title="Ajouter un lien utile"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            width={800}
            footer={null}
          >
            <form onSubmit={handleAddLien}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                      placeholder="Ex: Ministère du Commerce"
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Lien URL</label>
                    <input
                      type="url"
                      className="form-control"
                      value={lien}
                      onChange={(e) => setLien(e.target.value)}
                      placeholder="Ex: https://www.commerce.gov.bf"
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    Créer
                  </button>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal de modification de lien */}
          <Modal
            title="Modifier un lien utile"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            width={800}
            footer={null}
          >
            <form onSubmit={handleEditLien}>
              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="form-group">
                    <label>Lien URL</label>
                    <input
                      type="url"
                      className="form-control"
                      value={lien}
                      onChange={(e) => setLien(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary"
                  >
                    Mettre à jour
                  </button>
                </div>
              </div>
            </form>
          </Modal>

          {/* Modal de confirmation de suppression */}
          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                danger
                onClick={() => handleDelete(deleteLien.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>
              Êtes-vous sûr de vouloir supprimer ce lien utile ? Cette action est
              irréversible.
            </p>
          </Modal>

          {/* Modal pour afficher les détails */}
          <Modal
            title="Détails du lien utile"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingLien && (
              <div>
                <p>
                  <strong>ID:</strong> {viewingLien.id}
                </p>
                <p>
                  <strong>Nom:</strong> {viewingLien.nom}
                </p>
                <p>
                  <strong>Lien URL:</strong>{" "}
                  <a href={viewingLien.lien} target="_blank" rel="noopener noreferrer">
                    {viewingLien.lien}
                  </a>
                </p>
                <p>
                  <strong>Date de création:</strong>{" "}
                  {new Date(viewingLien.created).toLocaleString("fr-FR")}
                </p>
                <p>
                  <strong>Dernière mise à jour:</strong>{" "}
                  {new Date(viewingLien.updated).toLocaleString("fr-FR")}
                </p>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};

export default LienUtileAdmin;
